import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { api } from "../api";
import { Reveal, Eyebrow } from "./Reveal";
import { useApp } from "../store";

export const TestimonialsSection = () => {
  const { c, t, lang } = useApp();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section id="temoignages" data-testid="testimonials-section" className="relative text-white grain" style={{ background: "var(--sec-temoignages-bg, #101E3D)" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32 relative z-10">
        <Reveal className="max-w-2xl mb-14">
          <Eyebrow light>{t("testimonials_eyebrow")}</Eyebrow>
          <h2 data-testid="testimonials-title" className="mt-5 font-display font-semibold text-2xl sm:text-3xl lg:text-4xl tracking-tight">
            {c("testimonials_title")}
          </h2>
          <p data-testid="testimonials-sub" className="mt-4 text-sm sm:text-base text-white/60 leading-relaxed">
            {c("testimonials_sub")}
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((item, i) => (
            <Reveal key={item.id} delay={Math.min(i, 5) * 0.07}>
              <figure
                data-testid={`testimonial-card-${item.id}`}
                className="group h-full bg-white/[0.05] border border-[var(--accent-soft)]/10 p-7 flex flex-col justify-between transition-all duration-500 hover:border-[var(--accent-soft)]/50 hover:-translate-y-1"
              >
                <div>
                  <Quote size={26} strokeWidth={1.5} className="text-[var(--accent-soft)] mb-5" />
                  <blockquote className="font-display italic text-lg sm:text-xl leading-relaxed text-white/85">
                    « {lang === "fr" ? item.quote_fr : item.quote_en || item.quote_fr} »
                  </blockquote>
                </div>
                <figcaption className="mt-6 pt-5 border-t border-[var(--accent-soft)]/10">
                  <p className="font-semibold text-sm">{item.author}</p>
                  {(item.role_fr || item.role_en) && (
                    <p className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-[var(--accent-soft)] mt-1">
                      {lang === "fr" ? item.role_fr : item.role_en || item.role_fr}
                    </p>
                  )}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
